import * as React from 'react'

import {
  Box,
  Icon,
  NumberBadge,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { isQuestionRating } from 'modules/questionnaires/lib/helpers'
import { AnswerRatingContentProps } from 'modules/questionnaires/lib/types'

type CompetencyMetadata =
  | {
      competencyId?: number
      competencyLevelId?: number
      competencyLevelName?: string
      competencyLevelDescription?: string
    }
  | undefined
  | null

const CompetencyRatingQuestion = ({
  fallback,
  children,
  question,
  position,
}: AnswerRatingContentProps) => {
  const [open, toggle] = useToggle(false)
  const metadata: CompetencyMetadata = question?.metadata

  if ((question && !isQuestionRating(question)) || !metadata?.competencyLevelId) {
    return fallback
  }

  return (
    <Box flexDirection="column" gap="s16">
      <Box gap="s12" id={`question-${question?.uuid}`}>
        <Box flexDirection="row" alignItems="center" gap="s12">
          {position && <NumberBadge label={position} />}
          <Text.Normal size="300" weight="medium" color="grey1000" whiteSpace="breakSpaces">
            {question?.title}
          </Text.Normal>

          <Tooltip.Alt
            attachment={'middle left'}
            open={open}
            toggle={toggle}
            label={question?.description}
          >
            <Icon.Medium icon="info-circle" color="grey700" />
          </Tooltip.Alt>
        </Box>
        <Box flexDirection="column" gap="s8" paddingTop="s8">
          {metadata?.competencyLevelName && (
            <Text.Normal size="300" weight="medium" color="grey1000" whiteSpace="breakSpaces">
              {i18n.t('performance_process.competency_assessment.expected_level')}
            </Text.Normal>
          )}
          {metadata?.competencyLevelDescription && (
            <Text.Normal size="300" color="grey800" whiteSpace="breakSpaces">
              {metadata?.competencyLevelDescription}
            </Text.Normal>
          )}
        </Box>
      </Box>
      <Box width="full">{children}</Box>
    </Box>
  )
}

export default CompetencyRatingQuestion
